document.addEventListener('DOMContentLoaded', function () {
  let $contactForm = document.getElementById('jsContactForm');
  if ($contactForm) {
    const $btnToggleContactForm = document.querySelector('.js-toggle-contact-form');
    $btnToggleContactForm.addEventListener('click', function(e) {
      $contactForm.classList.toggle('is-open');
    });
  }
});